import React, { useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import { OverlayPanel } from 'primereact/overlaypanel';
import AvtarComponent from '../../../components/AvatarComponent';

const ChatHeaderInfo = (props) => {
    const op = useRef(null);
    const { selectedChat, userInfo } = props;
    const dispatch = useDispatch();
    useEffect(() => {
        if (selectedChat.groupChat) {
            dispatch(
                appActions.TOPIC_GET_REQUEST({ chatId: selectedChat.chatId }),
            );
        }

    }, [selectedChat]);

    const topic = useSelector((state) => state.chat.topic);

    const getUserLabel = (chatId) => chatId.charAt(0).toUpperCase();

    const getInitials = () => {
        const { groupChat } = selectedChat;
        if (groupChat && topic && topic.title) {
            const { title } = topic;
            const titleArr = title.split(' ')
            titleArr.pop()
            return titleArr
                .map((word) => word.charAt(0))
                .join('')
                .toUpperCase();
        }
        
        return selectedChat.chatUserName || selectedChat.chatId;
    };

    const getName = () => {
        const { groupChat } = selectedChat;
        if (groupChat && topic && topic.title) {
            return topic.title
        }
        
        return selectedChat.chatUserName || selectedChat.chatId;
    };

    const getOnlineStatus = () => {
        const { connected } = userInfo;
        if (connected === 'Y') {
            return 'online';
        }
        return 'away';
    };

    return (
        <div style={{ height: '80px' }}>
            <div className="chat-header">
                <div className="flex align-items-center justify-content-between w-full">
                    <div className="flex align-items-center">
                        <UserItem
                            initials={getInitials()}
                            name={getName()}
                            status={getOnlineStatus()}
                            selectedChat={selectedChat}
                        />
                    </div>
                    {selectedChat.groupChat && (
                        <div className="flex align-items-center">
                            <Button
                                icon="pi pi-users"
                                className="button-text mr-2"
                                onClick={(e) => op.current.toggle(e)}
                            >
                                <span className="ml-1">
                                    {topic &&
                                        topic.subscribers &&
                                        topic.subscribers.length}
                                </span>
                            </Button>
                            <OverlayPanel ref={op} dismissable>
                                {topic &&
                                    topic.subscribers &&
                                    topic.subscribers.map((user, index) => (
                                        <div
                                            key={index}
                                            className="flex align-items-center mb-2"
                                        >
                                            {user.avatar ? (
                                                <AvtarComponent username={user.avatar}/>
                                            ) : (
                                                // <AvtarComponent username={user.firstName +""+user.lastName}/>
                                                <AvtarComponent username={user.userId}/>
                                            )}
                                            <div>
                                                <div>{user.userId}</div>
                                            </div>
                                        </div>
                                    ))}
                            </OverlayPanel>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const UserItem = ({ initials, name, status, selectedChat }) => {
    const { groupChat } = selectedChat
    return (
        <div className="flex align-items-center">
            <div className="relative mr-2">
                <AvtarComponent username={initials}/>
                {!groupChat && (
                    <span className={`custom-badge ${status}`}></span>
                )}
                
            </div>
            <div className="flex align-items-center">
                <span className="text-xl">{name}</span>
            </div>
        </div>
    );
};

export default ChatHeaderInfo;
